import React from "react";
import "./Tooltip.scss";

type TooltipProps = React.PropsWithChildren<{
  content: React.ReactNode;
  position?: "top" | "bottom";
}>;

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  position = "top",
}) => {
  const tooltipClasses = `Tooltip ${
    position === "bottom" ? "Tooltip--bottom" : ""
  }`;

  return (
    <span className={tooltipClasses}>
      {children}
      <span className="Tooltip__content">{content}</span>
    </span>
  );
};
